import type { DashboardRouteName } from '@/modules/dashboard/types/dashboardRoutes.type';

export const DASHBOARD_ROUTE_NAMES = {
  WALLETS: 'wallets',
  CREATE_WALLET: 'create-wallet',
} as const;

export const DASHBOARD_ROUTE_PATHS = {
  [DASHBOARD_ROUTE_NAMES.WALLETS]: 'wallets',
  [DASHBOARD_ROUTE_NAMES.CREATE_WALLET]: '/create-wallet',
} as const satisfies Record<DashboardRouteName, string>;
